import {tns} from '../../../../node_modules/tiny-slider/src/tiny-slider'

export default {
  init() {

  },
  finalize() {

    // JavaScript to be fired on the home page, after the init JS


    if (window.location.hash) {
      if (window.location.hash.substring(1, 8) === 'feature') {
        $(window.location.hash + ' .feature-image-wrap').click();
      }

      if (window.location.hash.substring(1, 8) === 'ska') {
        $('html, body').animate({
          scrollTop: $('#feature-54').offset().top - 63,
        }, 1500, function () {
          $('#feature-54 .feature-content').slideDown();
          $(this).parents('#feature-54 .feature').addClass('expanded');
        });
      }
    }

    tns({
      container: '.my-slider',
      items: 1,
      autoplay: false,
      controls: true,
      mouseDrag: true,
      nav: false,
      controlsPosition: 'bottom',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js